<template>
	<VChart :option="chartOptions" class="w-full h-full" />
</template>

<script setup>
import { defineComponent, computed } from 'vue'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import { GridComponent, TooltipComponent } from 'echarts/components'
import VChart from 'vue-echarts'

use([
	CanvasRenderer,
	LineChart,
	GridComponent,
	TooltipComponent
])

const props = defineProps({
	data: {
		type: Array,
		required: true,
	},
})

const chartOptions = computed(() => ({
	grid: { left: 0, right: 0, top: 10, bottom: 0 },
	xAxis: {
		type: 'category',
		show: false,
		data: props.data.map((_, i) => i),
	},
	yAxis: { type: 'value', show: false },
	series: [
		{
			data: props.data,
			type: 'line',
			smooth: true,
			lineStyle: { width: 2, color: '#1a8ad4' },
			symbol: 'none',
			areaStyle: { color: 'rgba(100, 150, 250, 0.3)' },
		},
	],
	tooltip: { show: false },
}))
</script>

